import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-geosearch/assets/css/leaflet.css';
import { Canvas, Icon, Map as LeafletMap, Point } from 'leaflet';
import { LMap } from 'vue2-leaflet'; // no credit line in a map's corner, on any map (the user, 22 Oct 2026, #456)

LeafletMap.mergeOptions({
  attributionControl: false
});
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
}); // A map removed while it still moved threw "Cannot read properties of undefined (reading '_leaflet_pos')" (#254: the
// wizard's maps on a step change or a resize). remove() ends a pan at once, which fires one more moveend; vue2-leaflet
// reports moves 0.1 s late and its report then asked the removed map for its centre. Leaflet's own late timers (the end
// of a zoom animation, a wheel zoom) do the same. Two parts:
// - before a vue2-leaflet map goes, nothing hears its moves any more (its report and the app's handlers would only
//   start work for a screen that is gone) and a wheel zoom still waiting is dropped;
// - a removed map has no panes: where its pane lies is then the origin, as Leaflet already does for a pane not placed yet

var destroyMap = LMap.beforeDestroy;

LMap.beforeDestroy = function () {
  var map = this.mapObject;

  if (map) {
    map.off('moveend');
    if (map.scrollWheelZoom) clearTimeout(map.scrollWheelZoom._timer);
  }

  destroyMap.call(this);
};

var panePos = LeafletMap.prototype._getMapPanePos;

LeafletMap.prototype._getMapPanePos = function () {
  return this._mapPane ? panePos.call(this) : new Point(0, 0);
}; // A canvas renderer removed with a redraw still waiting threw "Cannot read properties of undefined (reading 'save')"
// (#431: the wizard's maps on a step change or a resize). A move redraws the canvas at once and forgets the frame a style
// change had asked for, so removing the renderer no longer cancels that frame, which then drew on a canvas that is gone.
// A redraw without a canvas does nothing


var redraw = Canvas.prototype._redraw;

Canvas.prototype._redraw = function () {
  if (this._ctx) return redraw.call(this);
  this._redrawRequest = null;
  this._redrawBounds = null;
};